import { Navigate } from 'react-router-dom'

const LandingPage = () => {
  return <Navigate to="/trends" replace />
}

export default LandingPage
